import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `LandingAccess/${dossierId}/CancelAccessRequest`, method: 'DELETE', body: { }, token: token })
}
